exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rosterUploadButtons{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster_upload/roster_upload_buttons.scss
// module id = 1341
// module chunks = 0